import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { SmsService } from './sms.service';
const service = new SmsService();

export interface SmsState {}

const SmsStore: Module<SmsState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async inviteToVideoRoom(context, payload: { candidateId: number; videocallRoomId: number }) {
         const response = await service.inviteToVideoRoom(payload.candidateId, payload.videocallRoomId);
         return response.data;
      },
   },
};

export default SmsStore;
